
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/about",
      function () {
        return require("private-next-pages/[lng]/about.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/about"])
      });
    }
  